'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
require('./Alert.css');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/**
 * Use alerts for messaging across the application.
 */
var Alert = function Alert(_ref) {
  var type = _ref.type,
    floating = _ref.floating,
    align = _ref.align,
    children = _ref.children;
  var alertClass = (0, _classnames2.default)('c-alert', {
    'c-alert-info': type === 'default' || !type,
    'c-alert--info': type === 'info',
    'c-alert--success': type === 'success',
    'c-alert--danger': type === 'danger'
  }, {
    'c-alert--floating': floating
  }, {
    'u-text-center': align === 'center',
    'u-text-right': align === 'right'
  });
  return _react2.default.createElement('div', {
    className: alertClass
  }, _react2.default.createElement('div', {
    className: 'o-flex'
  }, type === 'info' && _react2.default.createElement('div', {
    className: 'u-spacer-right-s if if-info'
  }), type === 'success' && _react2.default.createElement('div', {
    className: 'u-spacer-right-s if if-success-circle'
  }), type === 'danger' && _react2.default.createElement('div', {
    className: 'u-spacer-right-s if if-info'
  }), children));
};
Alert.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The alert type */
  type: _propTypes2.default.oneOf(['default', 'info', 'success', 'danger']),
  /** Use a floating alert */
  floating: _propTypes2.default.bool,
  /** Alignment of the content in the alert */
  align: _propTypes2.default.oneOf(['left', 'center', 'right']),
  /** Children to display within the alert */
  children: _propTypes2.default.node
} : {};
Alert.defaultProps = {
  type: 'default',
  floating: false,
  align: 'left'
};
exports.default = Alert;